import { IIconProps } from "../types"

export default function IconLR5(props: IIconProps) {
  const width = props.size || props.width || 56
  const height = props.size || props.height || 69
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 56 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4415 0.808481C26.8215 0.498481 29.5515 0.308481 32.5615 0.578481C35.5815 0.858481 38.8615 1.60848 41.5815 2.46848C44.3015 3.33848 46.4515 4.30848 47.9615 5.23848C49.4715 6.16848 50.3515 7.04848 51.2715 7.96848C52.1815 8.89848 53.1215 9.87848 53.7215 11.1485C54.3315 12.4185 54.5915 13.9785 54.7815 16.0285C54.9815 18.0785 55.1115 20.6185 54.9915 24.4285C54.8815 28.2385 54.5215 33.3185 53.8515 39.2085C53.1915 45.0985 52.2115 51.8085 51.2715 56.0085C50.3215 60.2085 49.4115 61.8985 48.0915 63.1785C46.7715 64.4685 45.0515 65.3485 43.0015 66.1085C40.9515 66.8785 38.5715 67.5285 36.2915 67.7885C34.0115 68.0485 31.8315 67.9185 29.6815 67.3485C27.5415 66.7785 25.4215 65.7685 23.4015 64.0285C21.3815 62.2885 19.4615 59.8085 16.4215 54.8285C13.3715 49.8485 9.21151 42.3685 6.44151 36.9085C3.67151 31.4585 2.31151 28.0385 1.49151 25.5185C0.681512 22.9985 0.421512 21.3685 0.451512 19.9185C0.481512 18.4685 0.811512 17.1985 1.27151 16.0185C1.72151 14.8285 2.31151 13.7185 3.43151 12.4485C4.55151 11.1785 6.21151 9.74848 8.74151 7.96848C11.2615 6.19848 14.6415 4.08848 17.3515 2.81848C20.0515 1.54848 22.0715 1.11848 24.4415 0.808481Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
